<template>
  <div class="etowerHeaderPage disFlex" :class="{ postnord: brand === 'postnord'}">
    <div class="mainCont">
      <div class="leftCont">
        <a class="goHome" :href="homeUrl" rel="noopener noreferrer">{{ $t('spww.home') }}</a>
        <el-dropdown v-for="parent in menuList" :key="parent.moduleUUID" :index="parent.moduleUUID" placement="bottom" @visible-change="parent.isShowBottom = !parent.isShowBottom" @command="handleSelectMenu">
          <span class="menu-title">
            <!-- {{ parent.resourceKey }} -->
            {{ language === 'en' ? parent.titleEn : parent.titleCn }}
            <i v-if="parent.isShowBottom" class="el-icon-caret-bottom" />
            <i v-else class="el-icon-caret-top" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="custom-popper">
              <el-dropdown-item v-for="child in parent.children" :key="child.moduleUUID" :command="{parentPath: parent.path, childPath: child.path, parentTitleEn: parent.titleEn}">{{ language === 'en' ? child.titleEn : child.titleCn }}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-for="parent in defaultMenuList" :key="parent.moduleUUID" :index="parent.moduleUUID" placement="bottom" @visible-change="parent.isShowBottom = !parent.isShowBottom" @command="handleSelectDefaultMenu">
          <span class="menu-title">
            {{ language === 'en' ? parent.title : parent.titleCn }}
            <i v-if="parent.isShowBottom" class="el-icon-caret-bottom" />
            <i v-else class="el-icon-caret-top" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="custom-popper">
              <el-dropdown-item v-for="child in parent.children" :key="child.title" :command="child.href">{{ child.title }}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="rightCont">
        <div class="right-menu">
          <!-- 语言切换 -->
          <lang-select class="right-menu-item hover-effect" />
          <!-- 个人信息 -->
          <el-button v-if="!name" class="login-btn" type="text" size="mini" @click="loginBtn">{{ $t("common.login") }}</el-button>
          <el-dropdown v-if="!!name" class="avatar-container" placement="bottom" trigger="click" @command="handleCommand" @visible-change="onVisibleChange">
            <div class="avatar-wrapper">
              {{ name }}
              <i v-if="isShowBottom" class="el-icon-caret-bottom" />
              <i v-else class="el-icon-caret-top" />
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <el-dropdown-item v-if="!disablePasswordLogin" command="1">
                {{ aggregatorIsSystemPwd ? $t('login.resetPassword') : $t('navbar.changePassword') }}
              </el-dropdown-item>
              <el-dropdown-item command="2" class="dropdown-logout">
                {{ $t('login.logout') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 修改密码 -->
    <el-dialog v-el-drag-dialog :title="$t('navbar.changePassword')" :visible.sync="isShowPasswordDialog" width="450px">
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordFormRules" :label-width="$t('navbar.passwordLabelWidth')" class="update-form">
        <el-form-item :label="$t('common.userEmail')">admin@amin.com</el-form-item>
        <el-form-item :label="$t('navbar.newPassword')" prop="password">
          <el-input
            v-model="passwordForm.password"
            size="mini"
            placeholder=""
            style="width:95%"
            type="password"
            @input="passwordForm.password = passwordForm.password.trim()"
          />
        </el-form-item>
        <el-form-item :label="$t('navbar.confirmpassword')" prop="password2">
          <el-input
            v-model="passwordForm.password2"
            size="mini"
            placeholder=""
            style="width:95%"
            type="password"
            @input="passwordForm.password = passwordForm.password.trim()"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="default" size="small" @click="isShowPasswordDialog=false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" size="small" @click="savePassword">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LangSelect from './components/LangSelect'
import { logout, queryMenu, queryMenuNew } from '@/api/user'
import RETURN_DATA from '@/utils/data/ubi'
import { formatMenuList } from '@/utils/common'
import baseUrl from '@/utils/baseUrl'
export default {
  components: {
    LangSelect
  },
  data() {
    return {
      baseURL: baseUrl,
      isShowBottom: true,
      isShowPasswordDialog: false,
      passwordForm: {
        password: '',
        password2: ''
      },
      passwordFormRules: {
        password: [{ required: true, validator: this.validatePassword, trigger: 'blur' }],
        password2: [{ required: true, validator: this.validatePassword2, trigger: 'blur' }]
      },
      defaultMenuList: [...RETURN_DATA().defaultMenu]
    }
  },
  computed: {
    ...mapGetters(['menuList', 'name', 'language', 'token', 'brand']),
    homeUrl() {
      const systemHost = localStorage.getItem('systemHost')
      const { origin, pathname } = location
      let url = (origin + pathname) || process.env.VUE_APP_BASE_API
      if (!!systemHost && systemHost !== 'null' && systemHost !== 'undefined') {
        if (systemHost.includes('etowertech')) url = 'https://' + systemHost
        else url = 'http://' + systemHost
      }
      return url
    },
    aggregatorIsSystemPwd() {
      return this.$store.state.user.partyInfo.aggregatorIsSystemPwd || false
    },
    // 指定 hostname 禁修改/重置密码
    disablePasswordLogin() {
      const arr = ['localhost', 'qa-crane.etowertech.com', 'uk.etowertech.com']
      return arr.includes(window.location.hostname)
    }
  },
  watch: {
    token: function(newValue, oldValue) {
      if (newValue) {
        if (this.menuList.length <= 0) this.getMenuListNew()
      }
    }
  },
  created() {
    if (this.menuList.length <= 0 && this.token) this.getMenuListNew()
    if (!this.token) this.$store.dispatch('user/logout')
  },
  methods: {
    loginBtn() {
      // let language = ''
      // if (this.language === 'zh') {
      //   language = 'zh_CN'
      // } else if (this.language === 'en') {
      //   language = 'en_US'
      // }
      // let href = loginSystem({
      //   returnUrl: window.location.origin + '/#/index',
      //   brand: 'tracking.etowertech.com',
      //   language
      // })
      // window.location.href = href
      this.$router.push({
        path: '/login'
      })
    },
    handleSelectDefaultMenu(index, indexPath) {
      let href = index
      window.open(href, '_blank')
    },
    handleSelectMenu({ parentPath, childPath, parentTitleEn }) {
      let host = window.location.host
      const systemHost = localStorage.getItem('systemHost')
      if (!!systemHost && systemHost !== 'null' && systemHost !== 'undefined') {
        host = systemHost
      }
      const { origin, hostname = '' } = location
      // const sysUrl = pathname.split('/')[1]
      // 跳转新域名
      // 本地启动根据返回
      if (hostname !== 'localhost') {
        let path = 'shipper'
        if (parentTitleEn === 'Logistor') path = 'logistor'
        else if (parentTitleEn === 'Integrator') path = 'aggregator'
        parentPath = origin + '/' + path
      }
      let newHref = `${parentPath}/#/sessionRedirect?brand=${host}&language=${this.language === 'zh' ? 'zh_CN' : 'en_US'}&redirect=${childPath}&type=switch`
      if (this.token) newHref += '&sessionId=' + this.token
      window.open(newHref, '_blank')
    },
    handleCommand(command) {
      if (command === '2') this.logout()
      else if (command === '1') {
        // this.isShowPasswordDialog = true
        // this.$nextTick(() => {
        //   this.$refs.passwordForm.resetFields()
        // })
        this.$router.push({
          path: '/login',
          query: {
            optionType: 'change',
            sessionId: this.token,
            aggregatorIsSystemPwd: this.aggregatorIsSystemPwd
          }
        })
      }
    },
    onVisibleChange(val) {
      this.isShowBottom = !val
    },
    // 获取菜单 新
    getMenuListNew() {
      const params = {
        sessionId: this.token
      }
      queryMenuNew(this.baseURL, params).then(res => {
        const menu = formatMenuList(res.data, this.language)
        // console.log(menu)
        this.$store.dispatch('user/set_menuList', menu)
      }, () => {
        this.$store.dispatch('user/logout').then(() => {
          window.location.reload()
        })
      })
    },
    // 获取菜单
    getMenuList() {
      queryMenu().then(res => {
        this.$store.dispatch('user/set_menuList', res.data)
      }, () => {
        this.$store.dispatch('user/logout').then(() => {
          window.location.reload()
        })
      })
    },
    async logout() {
      await logout(this.baseURL, { sessionId: this.$store.getters.token })
      this.$store.dispatch('user/logout').then(() => {
        window.location.reload()
        // window.location.href = process.env.VUE_APP_ETOWER_URL
      })
    },
    validatePassword(rule, value, callback) {
      if (!value || value.length < 6 || value.length > 30 || !/^[0-9A-Za-z]+$/.test(value)) {
        callback(new Error(this.$t('message.changePasswordTip1')))
      } else {
        if (this.passwordForm.password2 !== '') {
          this.$refs.passwordForm.validateField('password2')
        }
        callback()
      }
    },
    validatePassword2(rule, value, callback) {
      if (value === '') {
        callback(this.$t('message.changePasswordTip2'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error(this.$t('message.twoPasswordTip')))
      } else {
        callback()
      }
    },
    // 保存密码
    savePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.custom-popper {
  max-height: 80vh;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
  .etowerHeaderPage {
    min-width: 1120px;
    border-bottom: 1px solid #E5EDF5;
    background: $primaryColor;
    color: #fff;
    &.postnord {
      background: #8eddf9;
      color: #000;
      .mainCont .leftCont .menu-title {
        color: #000;
      }
      .right-menu {
        .login-btn {
          color: #000;
        }
        .avatar-container .avatar-wrapper {
          color: #000;
        }
      }
    }
    .mainCont {
      width: 1120px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      height: 50px;
      .leftCont {
        display: flex;
        align-items: center;
        .menu-title {
          padding: 0 20px;
          cursor: pointer;
          color: #fff;
          font-size: 16px;
        }
        .goHome {
          margin-left: 30px;
          margin-right: 20px;
          font-size: 16px;
        }
      }
      .rightCont {
        ul {
          li {
            a {
              padding: 8px 15px;
              &:hover {
                color: #85BAE5;
              }
            }
          }
        }
      }
    }
    .disFlex {
      display: flex;
      .fixWidth {
        padding-right:5px;
      }
      .remain {
        flex: 1
      }
    }
    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;
      display: flex;
      align-items: center;
      &:focus {
        outline: none;
      }
      .login-btn {
        color: #fff;
        margin-left: 15px;
        font-size: 16px;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;
        }
      }

      .avatar-container {
        margin-left: 10px;
        overflow: hidden;

        .avatar-wrapper {
          position: relative;
          cursor: pointer;
          color: #fff;
          font-size: 16px;

          .el-icon-caret-bottom,
          .el-icon-caret-top {
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
  }
  .user-dropdown {
    /deep/.el-dropdown-menu__item {
      width: 200px;
      text-align: center;
    }
  }
</style>
